import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { PlantsResponse, PlantsService } from '@cemex-core/cmx-api';
import {
  LOAD_PRODUCT_PLANTS,
  LoadProductPlantsAction,
  LoadProductPlantsCompleteAction,
  LOAD_PRODUCT_PLANTS_COMPLETE,
} from '../../actions/product-plants.actions';
import { SpecificationPopulatePlantsFromOpenCatalogAction } from '../../actions/specification.actions';

@Injectable()
export class ProductPlantsEffects {
  specificationLoadProductPlants$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_PRODUCT_PLANTS),
      switchMap((action: LoadProductPlantsAction) => {
        return this.plantService.getPlants(action.payload);
      }),
      filter((response) => {
        return response !== null;
      }),
      map((response: PlantsResponse) => new LoadProductPlantsCompleteAction(response)),
    ),
  );

  specificationLoadProcutPlantsComplete: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_PRODUCT_PLANTS_COMPLETE),
      map((action: LoadProductPlantsCompleteAction) => {
        return new SpecificationPopulatePlantsFromOpenCatalogAction(action.payload.plants);
      }),
      map((response) => {
        return response;
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private plantService: PlantsService,
  ) {}
}
